import { PRODUCT_TYPE_OPTIONS, SUBSCRIPTION_PRODUCT_TYPES } from "@/constants/generic";
import { selectProMemberships, selectELSAPremiumMemberships } from "@/constants/memberships";

export function arrayUnique(array) {
    var a = array.concat();
    for(var i=0; i<a.length; ++i) {
        for(var j=i+1; j<a.length; ++j) {
            if(a[i] === a[j])
                a.splice(j--, 1);
        }
    }

    return a;
}

export function getPlanLabel(product_type, plan_package = null) {
    const nonSubscription = PRODUCT_TYPE_OPTIONS.find(item => item.value === product_type);
    if (nonSubscription && !SUBSCRIPTION_PRODUCT_TYPES.includes(product_type)) {
      return nonSubscription.label; // Return directly if it's a lifetime package.
    }
    // For subscription types, determine the correct membership array.
    let membershipArray;
    if (product_type === 'elsa_speak') {
      membershipArray = selectProMemberships;
    } else if (product_type === 'premium') {
      membershipArray = selectELSAPremiumMemberships;
    }

    // Extract the label for the specific membership package.
    const membership =membershipArray && membershipArray.find(e => e.value === plan_package);
    const membershipLabel = membership && membership.label;

    return membershipLabel || 'Unknown Plan'; // Fallback to 'Unknown Plan' if no label is found.
}
